import React, { useEffect } from 'react';
import { validation } from '../../utils/handleChangeHooks';
import { isNullOrEmpty, leftPad, rightPad } from '../../utils/util';
import { connect } from 'react-redux';

const InputUI = (props) => {
    let inputRef;
    let propsUi = {};
    if (props) {
        Object.assign(propsUi, props);
        delete propsUi.config;
        delete propsUi.dispatch;
    }

    let isValidation = isNullOrEmpty(props.isValidation) || props.isValidation === true ? true : false;

    useEffect(() => {
        if (!isNullOrEmpty(props.value) || !isNullOrEmpty(props.defaultValue)) {
            const documentClass = inputRef.labels[0];
            if (documentClass && documentClass.className && !documentClass.className.includes('active')) {
                inputRef.labels[0].className = `${inputRef.labels[0].className} active`;
            }

            if (documentClass && documentClass.className === '') {
                inputRef.labels[0].className = 'active';
            }
        }
        // eslint-disable-next-line
    }, [props.value, props.defaultValue, props.required]);

    const onEnableKeyboardConfigNumber = () => {
        if (props.config && props.config.enableKeyboard === "1" && props.type === "number" && navigator.userAgent === 'logisticspwa') {
            var er = /[^0-9.]/;
            er.lastIndex = 0;
            if (er.test(inputRef.value)) {
                inputRef.value = "";
            }
        }
    }

    // Aceitar Somente numeros, sem espacos
    const onNumericOnly = () => {
        if (props.numericonly) {
            const formatted = inputRef.value.replace(/[^\d]|\s/gi, '');
            if (formatted !== inputRef.value) {
                inputRef.value = formatted;
            }
        }
    }

    const onPaddingChar = (event) => {
        if (!props.maxLength) {
            return;
        }
        let formattedVal = inputRef.value;

        if (props.padleftchar) {
            formattedVal = leftPad(inputRef.value, props.maxLength, props.padleftchar);
        }
        else if (props.padRightChar) {
            formattedVal = rightPad(inputRef.value, props.maxLength, props.padRightChar);
        }

        if (inputRef.value.length === 0 || formattedVal === inputRef.value) {
            return;
        }

        inputRef.value = formattedVal;
        event.target.value = inputRef.value;

        if (props.onChange) {
            props.onChange(event);
        }
    }


    const onChange = (event) => {
        onEnableKeyboardConfigNumber();
        onNumericOnly();
        if (isValidation === true) {
            validation(inputRef);
        }
        if (!isNullOrEmpty(inputRef.value) && inputRef.step === "1" && (inputRef.value.includes(".") || inputRef.value.includes(","))) {
            var newValue = event.target.value.replace(".", "").replace(",", "");
            event.target.value = newValue;
            inputRef.value = newValue;
        }

        if (props.leadingzeros && !isNullOrEmpty(event.target.value)) {
            var valueRepeat = "0".repeat(props.leadingzeros);
            var valueNew = (valueRepeat + event.target.value).slice(-props.leadingzeros);
            if (valueNew.length === parseInt(props.leadingzeros)
                && valueNew.replace(valueRepeat, "").length === 0) {
                event.target.value = ""
                inputRef.value = "";
            } else {
                event.target.value = valueNew
                inputRef.value = valueNew;
            }
        }

        if (props.onChange) {
            props.onChange(event);
        }
    };

    const onBlur = (event) => {
        onEnableKeyboardConfigNumber();
        if (isValidation === true) {
            validation(inputRef);
        }
        if (!isNullOrEmpty(inputRef.value) && inputRef.step === "1" && (inputRef.value.includes(".") || inputRef.value.includes(","))) {
            var newValue = event.target.value.replace(".", "").replace(",", "");
            event.target.value = newValue;
            inputRef.value = newValue;
        }
        onPaddingChar(event);
        if (props.onBlur) {
            props.onBlur(event);
        }
    };

    const numberInputOnWheelPreventChange = (e) => {
        if (e.target.type === "number") {
            e.target.blur()
            e.stopPropagation()
            setTimeout(() => {
                e.target.focus()
            }, 0)
        }
    }

    return (
        props.type === 'checkbox' ? (
            <div>
                <label>
                    <input
                        {...propsUi}
                        ref={(el) => inputRef = el}
                        onChange={onChange}
                        onBlur={onBlur}
                    />
                    <span className={props.required ? 'sixth-text-color required' : 'sixth-text-color'}>{props.label}</span>
                </label>
            </div>
        ) : (
            <>
                {
                    navigator.userAgent === 'logisticspwa' && props.config && props.config.enableKeyboard === "1" ? (
                        <input
                            {...propsUi}
                            ref={(el) => inputRef = el}
                            onChange={onChange}
                            onBlur={onBlur}
                            inputMode={"none"}
                            type="text"
                        />
                    ) : (
                        <input
                            {...propsUi}
                            ref={(el) => inputRef = el}
                            onChange={onChange}
                            onBlur={onBlur}
                            onWheel={numberInputOnWheelPreventChange}
                        />
                    )
                }
                {
                    !isNullOrEmpty(props.label) ? (
                        <label className={props.required ? 'required' : ''} htmlFor={props.id}>{props.label}</label>
                    ) : null
                }
            </>
        )
    );
};

const mapStateToProps = (state) => {
    return {
        config: state.configReducer.configUser,
    };
};

export default connect(mapStateToProps)(InputUI);

